import { Answers, CategoryKey, QuizStep } from "../types/quiz";

const PRIORITY: CategoryKey[] = ["nocturna", "fermentacion", "lenta", "estres", "motilidad", "sensibilidad"];

export function computeScores(steps: QuizStep[], answers: Answers): Record<CategoryKey, number> {
  const totals: Record<CategoryKey, number> = {
    nocturna: 0,
    fermentacion: 0,
    lenta: 0,
    estres: 0,
    motilidad: 0,
    sensibilidad: 0,
  };
  steps.forEach((step) => {
    if (step.kind !== "question") return;
    const option = step.options.find((o) => o.id === answers[step.id]);
    if (!option?.scores) return;
    (Object.keys(option.scores) as CategoryKey[]).forEach((key) => {
      totals[key] += option.scores?.[key] ?? 0;
    });
  });
  return totals;
}

export function rankProfiles(scores: Record<CategoryKey, number>): {
  primary: CategoryKey;
  secondary: CategoryKey | null;
} {
  const ranked = [...PRIORITY].sort((a, b) => scores[b] - scores[a] || PRIORITY.indexOf(a) - PRIORITY.indexOf(b));
  const [first, second] = ranked;
  const top = scores[first];
  const runnerUp = scores[second];
  const hasSecondary = runnerUp > 0 && (runnerUp === top || runnerUp >= top * 0.75);
  return { primary: first, secondary: hasSecondary ? second : null };
}

/** Labels of the options the user picked that contributed to a given category. */
export function signalsFor(steps: QuizStep[], answers: Answers, category: CategoryKey): string[] {
  const signals: string[] = [];
  steps.forEach((step) => {
    if (step.kind !== "question") return;
    const option = step.options.find((o) => o.id === answers[step.id]);
    if (option?.scores?.[category]) signals.push(option.label.replace(/[“”]/g, ""));
  });
  return signals.slice(0, 5);
}
